import { render, staticRenderFns } from "./subscribeDialog.vue?vue&type=template&id=decab8a0&scoped=true&"
import script from "./subscribeDialog.vue?vue&type=script&lang=js&"
export * from "./subscribeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decab8a0",
  null
  
)

export default component.exports